import { Gift, ArrowRight } from "lucide-react";
import { Reveal, MaskedLine } from "./Reveal";
import { scrollToId } from "../hooks/useLenis";

const BRANDS = ["IKEA", "Hemtex", "Cervera"];

export const GiftCardSection = () => (
  <section data-testid="giftcard-section-page" className="relative bg-[#16a34a] py-24 sm:py-32 grain overflow-hidden">
    <span
      aria-hidden
      className="absolute -right-8 -bottom-14 font-display font-extrabold text-[26vw] lg:text-[17rem] leading-none text-white/10 select-none pointer-events-none"
    >
      1000:-
    </span>
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8 text-center sm:text-left">
      <Reveal>
        <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-green-200 mb-6 flex items-center justify-center sm:justify-start gap-2">
          <Gift className="w-4 h-4" /> Studentpaketet
        </p>
      </Reveal>
      <h2 className="font-display font-extrabold tracking-tight leading-[1.05] text-white text-[clamp(1.8rem,7.5vw,4.5rem)]">
        <MaskedLine>{"Flyttar du via skolan? "}</MaskedLine>
        <MaskedLine delay={0.1}>{"Då ingår presentkort "}</MaskedLine>
        <MaskedLine delay={0.2}>
          {"för "}
          <span className="inline-block bg-white text-[#16a34a] px-4 rounded-2xl -rotate-1">1 000 kr</span>!
        </MaskedLine>
      </h2>
      <Reveal delay={0.2}>
        <p className="mt-7 max-w-xl mx-auto sm:mx-0 text-base sm:text-lg text-green-100 leading-relaxed">
          Alla studenter med utplacering får ett presentkort värt 1 000 kr – helt utan motkrav.
          Välj din favorit och fixa det nya rummet direkt efter flytten.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-wrap items-center justify-center sm:justify-start gap-3 sm:gap-4">
          {BRANDS.map((b) => (
            <span
              key={b}
              data-testid={`giftcard-brand-${b.toLowerCase()}`}
              className="font-display font-extrabold text-[#16a34a] bg-white rounded-full px-7 sm:px-9 py-3.5 sm:py-4 text-lg sm:text-2xl tracking-tight"
            >
              {b}
            </span>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.4} className="flex justify-center sm:justify-start">
        <button
          data-testid="giftcard-section-cta"
          onClick={() => scrollToId("#offert")}
          className="group mt-10 bg-[#0b0f19] hover:bg-black text-white font-semibold px-8 py-4 rounded-full inline-flex items-center gap-2 transition-colors duration-300"
        >
          Välj ditt presentkort i formuläret
          <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);
